module.exports = __webpack_public_path__ + "img/layersButton.28c51aca.png";